import React from 'react'
import AddFilter from '../../../../Components/Filters/AddFilter'

export default function AddCityFilter() {
  return (
    <AddFilter department="city"/>
  )
}
